import type { ReactElement } from 'react';
import { GeoMapCanvas } from '../../momentum-v3/GeoMapCanvas';
import { StudioBox, warnUnsupportedNode, type StudioNodeRendererProps } from './box';

/**
 * Map: reuses `GeoMapCanvas` exactly like `momentum-v2/GeoPage.tsx` does —
 * same provider seam (mapbox / OSM tiles / schematic fallback), just placed
 * at the resolver's box instead of the fixed full-bleed geo_strategy layout.
 */
export function MapNode({ node, ctx }: StudioNodeRendererProps): ReactElement {
  const { proposal, actions, readOnly } = ctx;
  return (
    <StudioBox node={node} className="tpl-studio-map" style={{ overflow: 'hidden' }}>
      <GeoMapCanvas
        advertiser={proposal.advertiser}
        geography={proposal.geography}
        readOnly={readOnly}
        appearance="light"
        onToggleZip={(nextZipCodes) => actions.setGeography({ zipCodes: nextZipCodes }, 'Updated ZIP targeting')}
      />
    </StudioBox>
  );
}

// ---------------------------------------------------------------------------
// Chart-family primitives: no data-binding contract yet (Stream B's
// SceneNodeProps carries no series/values shape) — stubbed pending that
// contract rather than guessing a binding scheme.
// ---------------------------------------------------------------------------

export function ChartNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function DonutNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function BarNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function TimelineNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function JourneyStageNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function FunnelNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function ConnectorNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}

export function FlowNode(props: StudioNodeRendererProps): null {
  warnUnsupportedNode(props.node);
  return null;
}
